import { SealCheck, Stack, UsersThree, GlobeSimple, Gauge } from "@phosphor-icons/react";
import { Container, Overline, SectionTitle } from "./Section";

const ICONS = [Stack, UsersThree, GlobeSimple, Gauge];

export default function Expertise({ t }) {
  const e = t.expertise;
  return (
    <section id="expertise" className="py-24 lg:py-32 bg-[#F4F5F7]">
      <Container className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Overline testid="expertise-overline">{e.overline}</Overline>
          <SectionTitle testid="expertise-title" className="mb-8">{e.title}</SectionTitle>
          <p className="text-base md:text-lg leading-relaxed text-[#5A6B7C] mb-10" data-testid="expertise-text">{e.text}</p>
          <p className="inline-flex items-center gap-3 border border-[#0B1B3D] text-[#0B1B3D] text-sm font-medium px-4 py-3" data-testid="expertise-certification">
            <SealCheck size={20} weight="light" />
            {e.certification}
          </p>
        </div>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-[#D5DBE3] border border-[#D5DBE3] self-start">
          {e.pillars.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <div key={p.name} data-testid={`expertise-pillar-${i}`} className="bg-white p-8 lg:p-10">
                <Icon size={26} weight="light" className="text-[#0B1B3D] mb-6" />
                <h3 className="font-heading text-sm font-bold tracking-[0.15em] uppercase text-[#0B1B3D] mb-3">{p.name}</h3>
                <p className="text-sm text-[#5A6B7C] leading-relaxed">{p.text}</p>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
